import notificationReducer from './NotificationReducer'

export default notificationReducer
